import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchRequestSubset,
    SearchProviderFieldType, ISearchProviderField
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_AppSuite_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_UI_APPSUITE_ID: {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WBId',       columnResourceName: 'colWBId',    alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    APPSUITE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id',         columnResourceName: 'colId',      alignment: HorizAlignment.Left}, domainOptions: {}},
    APPSUITE_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Suite Name', columnResourceName: 'colName',    alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SORT_ORDER:        {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Sort',       columnResourceName: 'colSort',    alignment: HorizAlignment.Right, numberFormat: "#,##0", columnWidthCharacters: 10}, domainOptions: { maxLength: 50}},
    PROFILE_NAME:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Profile',    columnResourceName: 'colProfile', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},

}

const UIAppSuiteSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_UI_APPSUITE_ID',
        id_ui: 'APPSUITE_ID',
        name:  'APPSUITE_NAME'},

    searchProviderFields: vUI_AppSuite_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_AppSuite_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}

const UIAppSuiteSearchAppSuiteByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "UIAppSuiteSearchAppSuiteByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'APPSUITE_ID', renderOptions: { }},
        {profileFilterName: 'Name',   searchProviderFieldId: 'APPSUITE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'APPSUITE_ID','APPSUITE_NAME','PROFILE_NAME', 'SORT_ORDER'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: UIAppSuiteSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const UIAppSuiteSearch: ISearch = {
    searchName: "Find App Suite",
    renderOptions: { ui5ResourceId: "UIAppSuiteSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [UIAppSuiteSearchAppSuiteByName]
}

PAEnvironment.registerBusinessObjectSearch("UIAppSuiteBO", "AppSuite", UIAppSuiteSearch, "App Suite Search")

export {UIAppSuiteSearch}